import { colors } from '../../colors';
var para = {
  messageColor: colors.tomatoRed
};
export default para;